export enum KuvaEnum {
  Ei = 1,
  On,
  Lisatty,
  Poistettu,
}
